export const countryOptions = [
    { value: 'f4fd9f60-6a06-4947-b94f-0b278a37bd71', label: 'Afghanistan' },
    { value: 'fa21d828-637e-4812-af59-5adadd67b3c6', label: 'Albania' },
    { value: '7be80600-a155-4b2c-b833-a98d3a51ff9b', label: 'Algeria' },
    { value: 'fd3ed8cb-5787-4e8e-acb8-f3a5b74eb05a', label: 'Andorra' },
    { value: 'd8c7bba6-8bd3-444e-a03e-8d40ea7e55d4', label: 'Angola' },
    { value: '93656fe5-90bf-41f2-85d4-7e9260fdefa2', label: 'Antigua and Barbuda' },
    { value: '19893700-4c5a-400d-9a43-dab08ef28f0d', label: 'Argentina' },
    { value: 'fdbbb6e9-3ab1-4c09-8eec-377be27fddc2', label: 'Armenia' },
    { value: '44e9acdd-b731-42d1-b7bc-5b30ce92d0b5', label: 'Australia' },
    { value: '00bd809f-3b6d-4e60-8e9d-a0f3b686fc77', label: 'Austria' },
    { value: 'ba9fd083-8c11-463c-b4ec-8954b6ac8f9e', label: 'Azerbaijan' },
    { value: '2913d7bc-700f-4845-802d-f3808d2c6763', label: 'Bahamas' },
    { value: '40955688-e274-4039-8de3-2112837bdee1', label: 'Bahrain' },
    { value: '4acea10f-0a57-4a6a-98e5-5e1f6b8c5539', label: 'Bangladesh' },
    { value: 'e71d5250-2efc-4d26-ab80-38a5f5de5f2a', label: 'Barbados' },
    { value: 'd4426119-8a12-47bf-8889-c1bdc0141c81', label: 'Belarus' },
    { value: 'ab020520-1152-468e-a144-cebcc7c13a3c', label: 'Belgium' },
    { value: '39ce38ba-fd32-45fc-9fba-fdc3447cae75', label: 'Belize' },
    { value: 'bdbb43b5-c1d5-4076-9a19-3cee651cacd0', label: 'Benin' },
    { value: '3653313d-0224-489a-b0a4-1d33c1d02a5d', label: 'Bhutan' },
    { value: '452a5f32-113c-4a15-a523-09fa5aa7ad66', label: 'Bosnia and Herzegovina' },
    { value: '12b8a279-2dd2-4426-a784-7e91820035e2', label: 'Botswana' },
    { value: '4a8fc96f-b406-4cf9-87e7-594774d289fe', label: 'Brazil' },
    { value: 'efc5f5f7-5d82-40eb-bb42-9515b21bbee9', label: 'Brunei Darussalam' },
    { value: '40f0d9e0-6d5e-4093-87fe-f9c4fbd1e95c', label: 'Bulgaria' },
    { value: 'fee4d869-ce9a-4985-8f54-cc2ca7eb7e95', label: 'Burkina Faso' },
    { value: 'ec948020-3c65-46fe-b902-749fefd1d2f2', label: 'Burundi' },
    { value: '56139ee4-7755-4293-8e12-68c29a645986', label: 'Cabo Verde' },
    { value: 'f2f4eae9-704d-4b32-9b06-3b67d60196a4', label: 'Cambodia' },
    { value: '235b65ff-5e86-475c-b2c6-72e5c38b31b9', label: 'Cameroon' },
    { value: '9e6f8bea-6350-4209-a07e-edd1de6e960a', label: 'Canada' },
    { value: 'a1baab17-6275-4ea0-8c0c-715381bbde2d', label: 'Central African Republic' },
    { value: '07d7792d-1cd8-4290-b944-4ac56da4f9a4', label: 'Chad' },
    { value: '826e5055-6875-4bfd-a8c4-2e5968ecb056', label: 'Chile' },
    { value: '8bb35d71-f266-480f-963b-6d50a0bb23e0', label: 'China' },
    { value: '2fa23928-79f9-4b3f-b77f-a685d624d7ac', label: 'Colombia' },
    { value: '3292b18d-f049-44b9-9e90-f30c74991f0c', label: 'Comoros' },
    { value: 'b350ca7b-dc15-49aa-8d44-445b31cd540b', label: 'Congo' },
    { value: '2325aa0f-7207-472e-88a8-178795180700', label: 'Costa Rica' },
    { value: '89358658-61b4-4cdc-bd4e-063abad86e18', label: 'Côte d`Ivoire' },
    { value: 'b8af7e7c-94f2-47a7-ab00-db6b3aec25df', label: 'Croatia' },
    { value: '48cf41f5-b8d1-4233-9394-323e15d1150d', label: 'Cuba' },
    { value: '715d1674-f222-45b9-a711-cc70ee66398f', label: 'Cyprus' },
    { value: '0e10abba-758b-4350-9097-52c32363cbce', label: 'Czechia' },
    { value: 'db53953d-acc2-4d75-b23a-90dcf89def7d', label: 'Democratic People`s Republic of Korea' },
    { value: 'fd3c5908-b350-490e-9e11-43f2b4a56826', label: 'Democratic Republic of the Congo' },
    { value: '1eff553c-9ea4-49d5-940f-09be4844e721', label: 'Denmark' },
    { value: '14ee83ea-92cd-4948-a724-a872e6e37224', label: 'Djibouti' },
    { value: '055dcf17-3e6c-40be-920c-6c343c47e936', label: 'Dominica' },
    { value: 'a8c2674f-e19f-4368-989c-b49060968264', label: 'Dominican Republic' },
    { value: '274bbe88-0bbe-44d9-9353-54a1b553d2cd', label: 'Ecuador' },
    { value: 'e8917166-5cb4-4a08-ac05-2eaa9723e21f', label: 'Egypt' },
    { value: '2b0035d3-f8a4-409e-81be-ced90fb55bba', label: 'El Salvador' },
    { value: '53f6b0ab-01cb-4d03-9a96-c223705e979d', label: 'Equatorial Guinea' },
    { value: 'cc51fbca-7d80-4887-a4d3-29f336251aaa', label: 'Eritrea' },
    { value: '471c864f-afb6-47c0-bbfa-6221836d413f', label: 'Estonia' },
    { value: 'b53e85d9-5bca-452e-a046-2a17bfba4d22', label: 'Eswatini' },
    { value: 'e7c294a6-9fe2-4798-b19d-37f0d4063e32', label: 'Ethiopia' },
    { value: 'ddefb65c-dbe9-4e16-b20c-b8f4427144a3', label: 'Fiji' },
    { value: '58947571-8cfc-4c2e-9010-435dce571827', label: 'Finland' },
    { value: 'e58d2881-c0fd-4b1f-b5ee-81c3b79b2f11', label: 'France' },
    { value: 'dfc036e9-ef3c-4545-ae6b-4d0a0a2214dc', label: 'Gabon' },
    { value: '8130744e-87ac-4d7c-8f2e-bf1fe63fa73c', label: 'Gambia (Republic of The)' },
    { value: 'bc730c72-592f-4bef-b126-52d0a8b8a23f', label: 'Georgia' },
    { value: 'cfdbf995-7e40-45d6-ac9b-6e5bc2771836', label: 'Germany' },
    { value: '76b5bf55-2c52-4d9a-85bd-dc35752e051c', label: 'Ghana' },
    { value: 'df0311cf-8ee9-45fb-b5e2-d3f5a8da0e65', label: 'Greece' },
    { value: 'c1839a68-f2a4-4c4b-8b76-306f9bd67bdb', label: 'Grenada' },
    { value: 'e9c6add7-7f64-4bee-968c-7aacc4dcb504', label: 'Guatemala' },
    { value: 'f5c5ba80-9545-48eb-88e3-08c14fd86773', label: 'Guinea' },
    { value: '39622ab4-4a97-4e29-b3ce-3426cfea32b0', label: 'Guinea Bissau' },
    { value: 'd59b5560-78f4-4207-8ddf-fafb1129e100', label: 'Guyana' },
    { value: 'b8d4ece1-8c66-4350-b27e-be4351bddb2e', label: 'Haiti' },
    { value: 'c0be8241-ab38-4ab3-afc7-ba402fed6277', label: 'Honduras' },
    { value: '93d3b3fb-2f5f-43b1-bff8-cfeb4f7c1c16', label: 'Hungary' },
    { value: 'c7f37bee-4ad2-4208-9e1e-12607d9349ba', label: 'Iceland' },
    { value: '79c60c31-d613-4d2e-8d51-843a0f43f118', label: 'India' },
    { value: 'fcb15229-a626-4bef-b3c0-70fc2354182b', label: 'Indonesia' },
    { value: 'f0989006-2c74-4b49-84a4-6c7fdc40497a', label: 'Iran (Islamic Republic of)' },
    { value: '48d3a2d4-d3ac-4aaa-9d53-fda11e90647a', label: 'Iraq' },
    { value: '6cbb45d3-766a-4f40-bdd0-a436da12b668', label: 'Ireland' },
    { value: '56710eef-181a-4541-a806-e334be47c7b5', label: 'Israel' },
    { value: 'fe5da86d-c96d-4de6-ab1a-12b979e13cf4', label: 'Italy' },
    { value: 'b650b5ff-959b-4732-a28e-119dbd1c7407', label: 'Jamaica' },
    { value: 'f3300544-24d5-40fd-bf62-4637b55620d3', label: 'Japan' },
    { value: 'ef169428-a5f4-4e82-8e9b-dc875931f6a0', label: 'Jordan' },
    { value: 'd1730f64-393d-4237-b2e7-aff8382fc5a7', label: 'Kazakhstan' },
    { value: 'c90989c8-3afb-4f14-bc14-ca39ba52728a', label: 'Kenya' },
    { value: '539c0728-dbe2-4154-bfce-0aacd9a6519f', label: 'Kiribati' },
    { value: '59260cf9-0169-477b-ac25-3be7f294eaeb', label: 'Kuwait' },
    { value: '0d16c370-5596-451f-8d34-5f6403b544f6', label: 'Kyrgyzstan' },
    { value: 'ab58baea-ca47-4dfe-9f88-8623c08e0369', label: 'Lao People`s Democratic Republic' },
    { value: 'b663e197-ce14-4840-8ad5-dfa22d48e790', label: 'Latvia' },
    { value: 'b7c8b895-7f6b-4dac-b6c3-4981364e1f14', label: 'Lebanon' },
    { value: 'ecf7c314-41b5-42ef-9542-a071497a9556', label: 'Lesotho' },
    { value: '82e995c6-6e23-4494-8c14-93b5bcfae1c3', label: 'Liberia' },
    { value: 'e3837a86-7522-4a51-a3d2-49c89051d8fe', label: 'Libya' },
    { value: '0e8e1fb1-9914-4d40-95a0-163d4b9fcc49', label: 'Liechtenstein' },
    { value: 'e1868ac9-ea14-47a1-a89a-ad32bae7f3ea', label: 'Lithuania' },
    { value: '70375be1-ac3a-46b2-9be6-b7824de518ef', label: 'Luxembourg' },
    { value: 'd6c3588b-dc06-4a90-bfe1-075fa3ad5fcf', label: 'Madagascar' },
    { value: '9363d136-cd13-49f8-9b63-f77fed8e37ae', label: 'Malawi' },
    { value: 'ac003e2d-e717-42b2-b824-71c749a689c5', label: 'Malaysia' },
    { value: '57be25e3-7bc8-4b4e-980a-cf1ef0b97188', label: 'Maldives' },
    { value: '45b960a8-544f-449a-a202-cf5c0fa4b6cc', label: 'Mali' },
    { value: 'b537dbf1-1a18-4cb8-b3a1-383489b853f3', label: 'Malta' },
    { value: '93eb8de7-0fb4-4810-833c-46e4f9859bc4', label: 'Marshall Islands' },
    { value: '89f306ee-9a02-49b4-b0fd-ac478a7a3c0d', label: 'Mauritania' },
    { value: '5249b072-e1ca-4ddd-970b-b749f306a681', label: 'Mauritius' },
    { value: 'dcf46651-de67-4119-8416-167c4f9aef1d', label: 'Mexico' },
    { value: '0e59bf38-32b4-4e0e-b6bf-4b7facbfe0e6', label: 'Micronesia (Federated States of)' },
    { value: '0c67e393-6d04-4dab-928f-a5596c877774', label: 'Monaco' },
    { value: '2410129d-efad-4a9c-963b-b49270010bed', label: 'Mongolia' },
    { value: '6ccfe3f1-1678-48c8-8719-c2b6d681f262', label: 'Montenegro' },
    { value: '87cf4723-a9dd-45f4-9f3f-c4f9d821b19d', label: 'Morocco' },
    { value: '887c585d-e138-4967-b8ec-a39288f3f803', label: 'Mozambique' },
    { value: '537a4187-22e6-463c-a78f-5cb3c96a63fe', label: 'Myanmar' },
    { value: '578ec78c-deb3-49a1-adab-d0cc78056137', label: 'Namibia' },
    { value: '810edf43-1c56-4432-8916-92d6376e2d74', label: 'Nauru' },
    { value: '5ab81165-e197-4146-83c8-3b978a8f11fc', label: 'Nepal' },
    { value: '01b6d943-6cd2-4f57-82ce-f3f65e878d4f', label: 'Netherlands (Kingdom of the)' },
    { value: '0a564f64-6755-46e5-8e67-6a35b917c85b', label: 'New Zealand' },
    { value: '4543805f-9e05-4356-a4c8-e88febf80c52', label: 'Nicaragua' },
    { value: '493d790e-fba2-4b8e-8d2c-665696721596', label: 'Niger' },
    { value: 'be6e2075-1067-4df4-a28a-6acc3e50d84d', label: 'Nigeria' },
    { value: '3420450e-e340-497f-bbde-d6a5d7e82eb3', label: 'North Macedonia' },
    { value: '968f8db1-f388-435f-b010-4359cd67447d', label: 'Norway' },
    { value: 'a1b2cf7f-9f5b-4326-bf35-b4b0166da38a', label: 'Oman' },
    { value: '88ea6817-62cc-40d5-a385-4a52909b5012', label: 'Pakistan' },
    { value: '657ec0cc-ff25-492a-aca1-b238e33269cd', label: 'Palau' },
    { value: 'f78d10b7-b815-43c6-9be7-8709fb880020', label: 'Panama' },
    { value: '49892648-1d38-4011-9a49-8856231ce9bd', label: 'Papua New Guinea' },
    { value: '25deb66b-c7c8-48d5-8cd5-752162265750', label: 'Paraguay' },
    { value: 'd9e392f1-5a5a-4ee6-a6ed-21f06fb95c76', label: 'Peru' },
    { value: '7d5dd4f2-82ef-4829-b207-651e01f15311', label: 'Philippines' },
    { value: '21964013-b76b-424c-9a32-8c57547d6db6', label: 'Plurinational State of Bolivia' },
    { value: 'e0df3759-e070-4624-a3c4-2b8d2be4749a', label: 'Poland' },
    { value: 'e6b208fa-bbde-4982-8c87-56e819fbcbd2', label: 'Portugal' },
    { value: '48b8db73-289a-4a88-9653-817a2a460eef', label: 'Qatar' },
    { value: '2fc95b55-cd19-4f60-97aa-713d00d4a048', label: 'Republic of Korea' },
    { value: '527ed3ea-0777-429b-9fa3-3b835f38699d', label: 'Republic of Moldova' },
    { value: '21986a1a-f3aa-44bc-b718-520665a67362', label: 'Romania' },
    { value: '1298b2fe-f5c2-4a78-bce7-65fb300721f6', label: 'Russian Federation' },
    { value: 'a32825d8-370b-4d6a-8a3a-7c908c8429fe', label: 'Rwanda' },
    { value: 'f17dfaf2-c1b6-4264-a0ce-8404b08c49d8', label: 'Saint Kitts and Nevis' },
    { value: '707b069a-c8aa-4db5-85fa-77d92c26e461', label: 'Saint Lucia' },
    { value: '84fd8ee2-1262-4eff-b1ac-1f15a798306b', label: 'Saint Vincent and the Grenadines' },
    { value: 'a9eecca2-ac40-4fb9-826f-2d934bbf65c5', label: 'Samoa' },
    { value: 'aeee1976-6bf3-4a3c-b0da-c88c303400d7', label: 'San Marino' },
    { value: 'ca5b33df-41f7-4466-a29c-2d3004fd16d2', label: 'Sao Tome and Principe' },
    { value: 'c9d22224-3fd8-48ed-848f-999a395fb961', label: 'Saudi Arabia' },
    { value: 'f13d1789-5da6-4ba3-b51d-ec1b6d375345', label: 'Senegal' },
    { value: '9a997922-a487-4fde-b70b-15c3c6d623b7', label: 'Serbia' },
    { value: '339e5793-4e5b-4a65-82a3-01f90ff0832c', label: 'Seychelles' },
    { value: 'b0f80d62-d01e-4a01-a1ad-d048dd2fc091', label: 'Sierra Leone' },
    { value: 'bff284c9-1f23-494d-bf91-d3c1409e03d1', label: 'Singapore' },
    { value: '4e17bb09-823f-4a49-b91f-bf7faf418b49', label: 'Slovakia' },
    { value: 'e4f923e4-4472-4181-aac6-1602f7e14018', label: 'Slovenia' },
    { value: '67b6cdb3-4df1-4244-977f-ee1e1cabe724', label: 'Solomon Islands' },
    { value: 'b25a71b0-c82b-4af0-8aeb-3dcf8f9fc35d', label: 'Somalia' },
    { value: '7a3b6218-d148-4892-8db7-8340c62b00be', label: 'South Africa' },
    { value: '02b7a392-8179-4627-aacb-ee48438e496c', label: 'South Sudan' },
    { value: '01f68e88-8cdd-43a3-8d7d-fe1a01ad2690', label: 'Spain' },
    { value: '4cdb06ac-f9e5-49b5-a537-d22c815c0a46', label: 'Sri Lanka' },
    { value: '291332a8-9ba4-45ee-8635-83cd3d56e7a5', label: 'Sudan' },
    { value: '00b9c065-aa27-472b-b161-e64f56017466', label: 'Suriname' },
    { value: '699d3dc5-d253-4fe9-881c-3e83483c0125', label: 'Sweden' },
    { value: '5e74c60c-5a0f-41e4-b0e1-e5b37a09a9e4', label: 'Switzerland' },
    { value: 'bfcaa096-826d-490d-ace6-38e48105679f', label: 'Syrian Arab Republic' },
    { value: 'b99e4e62-51e6-4b93-992e-f29b6073b2be', label: 'Tajikistan' },
    { value: '4614112a-31d8-4d6b-88c9-fd2487585195', label: 'Thailand' },
    { value: '2bc8e814-a944-4d48-8897-891c6266a982', label: 'Timor-Leste' },
    { value: 'fdca557b-e781-4720-b164-54a189a88f52', label: 'Togo' },
    { value: '7e0dc5ae-5a06-4ef2-82a3-ba89eb8d06c3', label: 'Tonga' },
    { value: '636f322d-d688-441b-a504-7bb0d29dc32f', label: 'Trinidad and Tobago' },
    { value: 'cd59f0b9-7e1e-4733-b0e8-9c3d849c6c9f', label: 'Tunisia' },
    { value: '685a7b54-4993-4013-b1dd-57a06b8559b9', label: 'Türkiye' },
    { value: 'cb0eaa5c-19cb-46a3-b8b1-f2e49b966300', label: 'Turkmenistan' },
    { value: '20287521-10d6-4b19-a3e7-dcfc39a898ef', label: 'Tuvalu' },
    { value: '924fa0aa-5d79-469c-a017-0ab580a68530', label: 'Uganda' },
    { value: 'b4d21cb2-d47a-4ac2-ac3a-0313033a0b3e', label: 'Ukraine' },
    { value: '144f1c72-d1fb-4e0c-920f-b0f4c43bd78e', label: 'United Arab Emirates' },
    { value: 'ae459d3c-573b-43f1-810a-83c46c3b4c87', label: 'United Kingdom of Great Britain and Northern Ireland' },
    { value: 'f5e1f9ec-ff8b-4142-a323-c2446901c988', label: 'United Republic of Tanzania' },
    { value: 'f958cb7e-7490-40a4-992e-1018eb53368d', label: 'United States of America' },
    { value: '7949a6d2-7557-467b-b1ac-d8dd5da02421', label: 'Uruguay' },
    { value: 'f7da8101-91b4-4943-b51f-cf40477ede36', label: 'Uzbekistan' },
    { value: '9a697dac-be40-49c2-a28c-b75229696580', label: 'Vanuatu' },
    { value: '5633af18-4cbc-425c-abb5-b0a2ca9a4e52', label: 'Venezuela (Bolivarian Republic of)' },
    { value: '3af5e488-d37b-446e-864f-0654ab04ce9c', label: 'Viet Nam' },
    { value: '68f95db7-5d1c-4791-98e7-672158c6c103', label: 'Yemen' },
    { value: 'b7a04b9b-97a3-4f34-b4b5-7523bd68e8ad', label: 'Zambia' },
    { value: 'ff882031-7423-4e25-b3bd-468c12521667', label: 'Zimbabwe' }
]

// Helper function to create localized country options
export const createCountryOptions = (t: any, originalCountryOptions: any[]) =>
    originalCountryOptions.map(option => ({
        ...option,
        label: t(`countries.${option.label.toLowerCase()}`) || option.label
    }));